import { production_1 , staging_1} from "./index";


const config = {  
   ...(process.env.REACT_APP_BUILD_ENV === "PROD" ? production_1 : staging_1),
  // ...(process.env.REACT_APP_BUILD_ENV === "PROD" ? production_1 : production_1),
};

export default config